import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

import PropTypes from "prop-types";

// @mui/material components
import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// core components
import Button from "../components/Button.jsx";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from '@mui/material/Divider';
import { TextField} from '@mui/material';
import { Collapse } from '@mui/material';
import { Alert } from '@mui/material';


import { TiposInstalacionReserva, PopUpResult, ResultadoReserva, Roles, TipoExtraInstalaciones, DialogOthelloResult } from '../othelloConstantes.jsx';
import { getCurrentDataFormulario } from '../othelloFunciones.jsx';

import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloTitulo from '../componentsothello/OthelloTitulo.jsx';
import OthelloPopUpResult from '../componentsothello/OthelloPopUpResult.jsx';

import OthelloFooter from '../componentsothello/OthelloFooter.jsx';

import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import Icon from "@mui/material/Icon";

export default function ReservarAmpliar({ ...props })
{
    const { instalacion, reserva, onModalResulAmpliar, desdeticketreserva, modoexterno  } = props;
    
    const [loading, setLoading] = React.useState(true);       
    const [loadingextras, setLoadingextras] = useState(false);    

    const [paso, setpaso] = React.useState(1);    

    const [tramo, settramo] = React.useState([]);
    const [tramoamplia, settramoamplia] = React.useState([]);

    const [extrasdispo, setextrasdispo] = React.useState([]);
    const [extraselected, setextraselected] = useState([]);
    
    const [infopago, setinfopago] = React.useState(null);       
    
    const [alert, setalert] = React.useState(null);
    const [erroralert, seterroralert] = React.useState(null);

    const [pagando, setpagando] = React.useState(false);
      
    const [infoextraerror, setinfoextraerror] = useState("");

    const [showCodigoDescuento, setShowCodigoDescuento] = useState(false);
    const [codigoDescuento, setCodigoDescuento] = useState('');
    const [errorCodigoDescuento, setErrorCodigoDescuento] = useState(false);

    React.useEffect(() =>
    {       
        getDataPage();
    }, [loading]);

    const getDataPage = () =>
    {        
        if (reserva != null)
        {
            let IdsTramos = [];
            IdsTramos.push(reserva.id_Tramo);

            var jsonData = JSON.stringify({ id_oficina: reserva.id_Oficina, id_reserva: reserva.id_Reserva, id_instalacion: reserva.id_Instalacion, Ids_Tramo: IdsTramos });

            fetch('api/Data/GetInstalacionTramosReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null) {
                    settramo(res);
                    setLoading(false);
                }
                else {
                    settramo(null);
                    setLoading(false);
                }
            }).catch(error => {
                settramo(null);
                setLoading(false);
            });
        }
    }

    const onClosePopUpResult = () => {
        setalert(null);
    }

    React.useEffect(() => {

        if (paso == 2) {
            getDispoExtrasInstalacion(reserva.fecha);
        }        
    }, [paso]);
  

    const getDispoExtrasInstalacion = (fecha) =>
    {
        if (reserva != null && fecha != null)
        {
            setLoadingextras(true);

            var jsonData = JSON.stringify({ id_instalacion: reserva.id_Instalacion, fecha: fecha });

            fetch('api/Data/GetExtrasDisponibilidadInstalacion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                setextrasdispo(res);
                setLoadingextras(false);

                //SI no hay entonces paso al siguiente
                if (res != null && res.length == 0) {
                    setextraselected([]);
                    setpaso(3);
                }

            }).catch(error => {               
                setpaso(3);

                setextrasdispo(null);
                setLoadingextras(false);
            });
        }
    }

    
    const getTituloPaso = (paso, pasoactual) =>
    {
        if (paso == 1)
            return <Grid item xs={12}><OthelloTitulo titulo="Seleccione la ampliacion que desea para su reserva" backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 2) 
            return <Grid item xs={12}><OthelloTitulo titulo={"Extras"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 3)             
            return <Grid item xs={12}><OthelloTitulo titulo={"Datos de la Ampliacion de la Reserva"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
        else if (paso == 4) 
            return <Grid item xs={12}><OthelloTitulo titulo={"Pago"} backgroundColor={pasoactual != paso ? "#1976d2" : null} /></Grid>;        
    }
   
    const getNavegacionPaso = (onBack) => {
        return <MDBox
            sx={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'right',
                width: '100%',
                position: 'relative',
                marginTop: 0.5,
                paddingTop: 2,
                paddingBottom: 2,
                borderTop: '1px solid #e0e0e0',
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',                
                pr: 3
            }}
        >
            <Button color="secondary" onClick={onBack}>Volver</Button>
        </MDBox>        
    }
    
    function TratarTexto(infoshow) {
        if (!infoshow) return "";
        
        return (
            <MDBox
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    borderRadius: 2,
                    padding: 2,
                    mt: 1,
                    mb: 1,
                }}
            >
                <InfoOutlinedIcon sx={{ color: '#0ea5e9', mr: 1, mt: 0.5 }} />
                <MDTypography
                    variant="body2"
                    sx={{
                        color: '#374151',
                        lineHeight: 1.6,
                        whiteSpace: 'pre-line', // esto interpreta \n como saltos de línea
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: infoshow }} />
                </MDTypography>
            </MDBox>
        );
    }
  
    
    const getPrecioTramosExtrasSegunSituacion = (item, nuevoEstadoSocio) => {

        let PrecioFinal = item.precio;
        let EstadoFInalSocio = nuevoEstadoSocio != null ? nuevoEstadoSocio : false;//socioActivado;

        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        if ((item.pax == null || (item.pax != null && item.pax<= 1 )) && EstadoFInalSocio && item.precioReducido > 0)
            PrecioFinal = item.precioReducido;

        return PrecioFinal;
    }
    
    const getResumenTotalesReservaSegunSituacion = () =>
    {        
        //GESTION DE PRECIOS
        var precio = 0;      
        var precioExtras = 0;

        //Obtenemos los precios de los tramos seleccionados
        if (tramoamplia != null && tramoamplia.length > 0) 
        {
            tramoamplia.forEach(x =>
            {
                //Si estamos en modo horario
                if (reserva.tipoInstalacion == TiposInstalacionReserva.Horaria)
                    precio = precio + (1 * x.total);                    
                else 
                    precio = precio + (1 * x.precio);                    
            });            
        }

        //Ahora sumamos los extras
        if (extraselected != null && extraselected.length > 0)
            extraselected.forEach(x => precioExtras = precioExtras + x.total);

        var TotalPrecio = precio + precioExtras;

        //GESTION DE RESUMEN
        //Ahora hacemos el resumen de precios
        let conceptosResumenPrecio = [];
      
        let conceptoPrincipal = "Precio base";

        conceptosResumenPrecio.push({ descripcion: conceptoPrincipal, total: precio });
        
        if (extraselected != null && extraselected.length > 0)
            extraselected.forEach(x => conceptosResumenPrecio.push({ descripcion: x.concepto, total: x.total }));

        return {
            totalprecio: TotalPrecio, totalplazas: 1, conceptosresumen: conceptosResumenPrecio
        }
    }   

    const pasoAtras = () => {
        if (paso == 2) 
            setpaso(1);            
        else if (paso == 3)   
        {
            if (extrasdispo != null && extrasdispo.length > 0) {
                setpaso(2);
                setextraselected([]);
            }
            else
                setpaso(1);            
        }        
    }    

    const onClickHorarioTramoReserva = (horas, precioFinal) =>
    {
        if (tramo != null && tramo.length > 0 && paso == 1)
        {
            var array = [...tramo];
            var tramoampliaaux = [];

            array.forEach(x =>
            {
                let nuevo = {
                    horas : horas,
                    cantidad : x.cantidad = 1,
                    total :  precioFinal,
                    descripcion : /*tramoselected.descripcion */"Ampliacion (" + horas + " horas)"
                }

                tramoampliaaux.push(nuevo);
            })

            settramoamplia(tramoampliaaux);
        }
    }
    
    const onClickTramoContinuar = () =>
    {        
        setpaso(2);                    
    }
    
    const handleAddExtraReserva = (item) =>
    {
        let extrasNuevo = [...extraselected];

        if (extraselected.some(x => x.id_Extra == item.id_Extra))
            extrasNuevo = extrasNuevo.filter(x => x.id_Extra != item.id_Extra);

        let combocantidad = document.getElementById("cantidad" + item.id_Extra);
        var cantfinal = Number(combocantidad != null ? combocantidad.value : 1);

        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(item);

        extrasNuevo.push({ id_Extra: item.id_Extra, cantidad: cantfinal, precio: PrecioFinal, total: PrecioFinal * cantfinal, concepto: item.descripcion });

        setextraselected(extrasNuevo);
    };
    
    const handleEliminarExtraReserva = (item) => {
        let extrasNuevo = [...extraselected];

        if (extraselected.some(x => x.id_Extra == item.id_Extra))
            extrasNuevo = extrasNuevo.filter(x => x.id_Extra != item.id_Extra);

        setextraselected(extrasNuevo);
    };

    const onClickAceptarExtras = () => {

        setpaso(3);
    }
  
    const handleAplicarCodigoDescuento = () => {
        // Simula validación del código (puedes conectar esto con lógica real)
        if (codigoDescuento.trim().toLowerCase() !== 'opera2025') {
            setErrorCodigoDescuento(true);
        } else {
            setErrorCodigoDescuento(false);
            // Aplica el descuento aquí
        }
    };

    const grabarAmpliarReserva = () => {

        //Obtengo los datos
        let formulario = document.getElementById('formampliar');

        let reservasend = getCurrentDataFormulario(formulario)
       
        //let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        var jsonData = JSON.stringify({ reserva: reservasend, desdeticketreserva: desdeticketreserva, modoexterno: modoexterno  });

        fetch('api/Data/GrabarReservaAmpliar', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            if (res != null && res.ok) {
                if (res.resultado == ResultadoReserva.OkAFaltaDePago) {
                    setpaso(4);
                    setinfopago(res.infopago);
                    seterroralert(null);
                }
                else {
                    setalert(PopUpResult.OK);
                    setLoading(false);
                    setpaso(1);
                    settramo(null);
                    setinfopago(null);
                    seterroralert(null);

                    if (onModalResulAmpliar != null)
                        onModalResulAmpliar(0, DialogOthelloResult.OK, res.retorno)
                }
            }
            else {
                setalert(PopUpResult.KO);
                seterroralert(res.exception);
            }           
        }).catch(error => {
            setalert(PopUpResult.KO);
            seterroralert(error);                
        });
    }

    const realizarPago = (event) => {
        setpagando(true);
    }   

    function renderSelecionTramos()
    {
        if (tramo != null && tramo.length > 0) {
            let botonContinuar = tramo != null && tramo.length > 0 ?
                <MDBox ml={0} mr={0} mt={3} mb={2}>
                    <Button fullWidth round color={"primary"} onClick={() => onClickTramoContinuar(tramo[0])}>Continuar Reserva</Button>
                </MDBox> : "";

            let opcionesInstalacionHoraria = "";

            //Si estamos en modo horario y ya el cliente ha selccionado un tramo, le pongo las opciones disponibles (horas por contratar)
            if (reserva.tipoInstalacion == TiposInstalacionReserva.Horaria && tramo != null && tramo.length > 0)
                opcionesInstalacionHoraria = renderOpcionesInstalacionHoraria(tramo[0]);
            
            return <MDBox p={2} width="100%">            
                {opcionesInstalacionHoraria}
                {botonContinuar}
            </MDBox>;
        }
        else
            return "";
    }
    
    function renderItemOpcionHoraria(index, horas, precioHora, precio24Horas, es24Horas, selected)
    {
        let precioFinal = es24Horas ? precio24Horas : horas * precioHora;

        //Si el precio hora es
        if (precio24Horas < precioFinal)
            precioFinal = precio24Horas;

        let shadow = true;

        return (<Grid item xs={12} md={6} lg={3}>
            <MDBox m={0} >
                <Card sx={{
                    display: 'flex', flexDirection: 'column',
                    border: selected
                        ? '2px solid #1a73e8'
                        : '1px solid #e0e0e0',
                    boxShadow: (theme) => (shadow ? theme.boxShadows.lg : 'none'),                  
                    borderRadius: 2,
                    cursor:  'pointer',
                    opacity:  1,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow:  12,
                        transform: 'scale(1.01)',
                    },
                }} onClick={() => onClickHorarioTramoReserva(es24Horas ? 24 : horas, precioFinal)}>
                   
                    <MDBox sx={{ display: 'flex' }} p={1}>                                          
                        <MDBox sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }} mr={2} ml={2}>                            
                            <MDTypography variant="subtitle1" color="text.secondary" component="div">
                                Ampliar {horas} {horas>1? "horas" : "hora" }
                            </MDTypography>                            
                        </MDBox>
                    </MDBox>                   
                    <MDBox
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1px solid #e0e0e0',
                            backgroundColor: '#fafafa',
                            px: 2,
                            py: 1.5,
                            pl: 2
                        }}
                    >
                        <MDBox display="flex" gap={1} flexWrap="wrap">
                            <MDBox
                                display="flex"
                                alignItems="center"
                                px={2}
                                py={0.75}
                                borderRadius="lg"
                                sx={{
                                    backgroundColor: '#FF6F61',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon>
                                {precioFinal + "€"}
                            </MDBox>
                        </MDBox>                        
                    </MDBox>
                </Card>
            </MDBox>
        </Grid>);


    }

    function renderOpcionesInstalacionHoraria(tamoselected)
    {
        if (tamoselected != null && tamoselected.itemsHoraria != null && tamoselected.itemsHoraria>0)
        {       
            let itemsOpciones = [];
            let horasReservar = 0;
            

            for (var i = 0; i < tamoselected.itemsHoraria; i++)
            {
                horasReservar += tamoselected.periocidadHoraria;

                let selected = tramoamplia != null && tramoamplia.some(x => x.horas == horasReservar);

                let opcion = renderItemOpcionHoraria(0, horasReservar, tamoselected.precioHora, tamoselected.precio, false, selected)

                if (opcion != null && opcion != "")
                    itemsOpciones.push(opcion);
            }

            //Si tenemos que mostra el 24horas
            if (tamoselected.item24horas == 1)
            {
                let selected24h = tramoamplia != null && tramoamplia.some(x => x.horas == 24);
                itemsOpciones.push(renderItemOpcionHoraria(tamoselected.itemsHoraria + 1, 24, tamoselected.precioHora, tamoselected.precio, true, selected24h));
            }

            //if (tamoselected.opcionAnyHora == 1)
            //    itemsOpciones.push(renderItemOpcionHoraria(tamoselected.itemsHoraria + 2, horasReservar, tamoselected.precioHora, tamoselected.precio, false, true));
               
            return <>               
                <Grid container spacing={3} mt={0}>
                    {itemsOpciones}
                </Grid>
            </>
        }
        else return "";
    }


    const renderExtra = (item) => {

        const hasImage = item?.image && item.image.trim() !== "";
        let CantidadSelected = 1;
        let EstaSeleccionado = false;

        if (extraselected != null && extraselected.length>0 && extraselected.some(x => x.id_Extra == item.id_Extra)) {
            let selected = extraselected.find(x => x.id_Extra == item.id_Extra);
            if (selected != null) {
                CantidadSelected = selected.cantidad;
                EstaSeleccionado = true;
            }
        }

        var Normales = Number(1/*plazas*/);
        var Reducidas = Number(0/*plazasReducidas*/);
        var Gratuitas = Number(0/*plazasGratuitas*/);

        var TotalPlazas = Normales + Reducidas + Gratuitas;

        if (item.tipoExtra === TipoExtraInstalaciones.Libre)
            TotalPlazas = 20;

        let valoresCombo = [];
        for (var i = 1; i <= TotalPlazas; i++)
            valoresCombo.push({ valor: i, name: i });

        //Si esta el numero de socio activo y existe precio de descuento le doy el de descuento y pongo el normal como el disabled, para que se vea el precio inicial
        let PrecioFinal = getPrecioTramosExtrasSegunSituacion(item);

        return (<Grid item xs={12} md={6} lg={4}>
            <MDBox m={1} >
                <Card sx={{ display: 'flex', flexDirection: 'column', }}>
                    <MDBox sx={{ display: 'flex' }} p={1}>
                        <MDBox
                            sx={{
                                width: 120,
                                height: 120,
                                mr: 2,
                                borderRadius: 2,
                                backgroundImage: hasImage ? `url(${item.image})` : 'none',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundColor: hasImage ? 'transparent' : '#f0f0f0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {!hasImage && <PhotoCamera fontSize="large" />}
                        </MDBox>
                    
                        <MDBox sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }} mr={2}>
                            <MDTypography component="div" variant="h6">
                                {item.codigo}
                            </MDTypography>
                            <MDTypography variant="subtitle1" color="text.secondary" component="div">
                                {item.descripcion}
                            </MDTypography>
                            <MDTypography variant="body2" color="text.secondary" mt={1}>
                                {item.infoAdicional}
                            </MDTypography>
                        </MDBox>
                    </MDBox>                  
                    
                    <MDBox
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1px solid #e0e0e0',
                            backgroundColor: '#fafafa',
                            px: 2,
                            py: 1.5,
                            pl: 2
                        }}
                    >                        
                        <MDBox display="flex" gap={1} flexWrap="wrap">
                            <MDBox
                                display="flex"
                                alignItems="center"
                                px={2}
                                py={0.75}
                                borderRadius="lg"
                                sx={{
                                    backgroundColor: '#FF6F61',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                }}
                            >
                                <Icon sx={{ fontSize: 18, mr: 1 }}>credit_card</Icon>
                                {PrecioFinal > 0 ? PrecioFinal + "€" : "Free"}
                            </MDBox>
                        </MDBox>                                               
                        <MDBox display="flex" alignItems="center" minHeight={60}>
                            {item.tipoExtra === TipoExtraInstalaciones.PorPax || item.tipoExtra === TipoExtraInstalaciones.Libre ?
                                <MDBox border="1px solid #ccc" borderRadius="md" bgColor="white" mr={1} mt={0} pb={0.8} px={0.5}>
                                    <OthelloComboBox labelliteral="_cantidad" fieldname={"cantidad" + item.id_Extra} items={valoresCombo} currentvalue={CantidadSelected} disabled={EstaSeleccionado} />
                                </MDBox> : ""}
                            {EstaSeleccionado ? (
                                <>
                                    <MDBox display="flex" alignItems="center" color="green" mr={0.5}>
                                        <Icon sx={{ mr: 0.5 }}>check_circle</Icon>
                                        <MDTypography variant="body2">Añadido</MDTypography>
                                    </MDBox>
                                    <Button color="error" iconOnly onClick={() => handleEliminarExtraReserva(item)}>
                                        <Icon>delete</Icon>
                                    </Button>
                                </>
                            ) :
                                <Button variant="contained" color="success" onClick={() => handleAddExtraReserva(item)}>
                                    Añadir
                                </Button>
                            }
                        </MDBox>
                    </MDBox>                   
                </Card>
            </MDBox>
        </Grid>);
    }

    function renderExtrasReserva() {

        if (loadingextras)
            return "Buscando extras, un momento por favor..."
        else
        {
            let finales = extrasdispo != null && extrasdispo.length > 0 ? extrasdispo.map(x => renderExtra(x)) : "";

            return <>
                {finales}
                <Grid container justifyContent="center" mt={2}>
                    <Grid item xs={12} mx={1}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() => onClickAceptarExtras()}
                            sx={{ borderRadius: 2, textTransform: 'none',  }}
                        >
                            Continuar Reserva
                        </Button>
                    </Grid>
                </Grid>
               </>;
        }
    }

    function ResumenReservaMUI(conceptosResumenPrecio, total) {

        let porconcepto = [];

        if (conceptosResumenPrecio != null && conceptosResumenPrecio.length > 0)
        {
            porconcepto = conceptosResumenPrecio.map(x => <MDBox sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <MDTypography variant="caption" fontSize={15} >{x.descripcion}</MDTypography>
                <MDTypography variant="caption" color="text.secondary" fontSize={15} sx={{ textAlign: 'right', minWidth: '60px' }}>
                    {x.total.toFixed(2)} €
                </MDTypography>
            </MDBox>)
        }

        return (
            <MDBox>                
                {porconcepto }              
                <Divider sx={{ my: 1 }} />
                <MDBox sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    //color: blue[500],
                    fontWeight: 'bold',
                }}>
                    <MDTypography variant="body2" fontWeight="bold">Total</MDTypography>
                    <MDTypography variant="body2" fontWeight="bold" sx={{ textAlign: 'right', minWidth: '60px' }}>
                        {total.toFixed(2)} €
                    </MDTypography>
                </MDBox>
            </MDBox>
        );
    }

    function renderDatosReserva()
    {      
        //Obtenemos el precio       
        var Totales = getResumenTotalesReservaSegunSituacion();          
        
        let horas = 0;
        
        tramoamplia.forEach(x => { horas = x.horas; });        

        // estoy aqui controlando que la cantida final es la correcta, que el precio es el bueno, y tendria que controlar que la cantidad de maximas disponible es correcta cuando estan metiendo las plazas en el paso concreto        
        return <Grid item xs={12}>          
            <MDBox p={2}>
            <Grid container spacing={2} >                       
                    <Grid item xs={12} mb={4} >
                    <Card sx={{ position: "sticky", top: 80, p: 0 }}>
                            {instalacion != null && instalacion.image && (
                            <img
                                src={instalacion.image}
                                alt="Instalación"
                                style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "cover",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px"
                                }}
                            />
                        )}
                            <CardContent>
                                <form id="formampliar">                                   
                                    <input type="hidden" name="Id_Oficina" value={reserva != null ? reserva.id_Oficina : -1} />
                                    <input type="hidden" name="Id_Usuario" value={reserva != null ? reserva.id_Usuario : -1} />
                                    <input type="hidden" name="Id_Instalacion" value={reserva != null ? reserva.id_Instalacion : -1} />
                                    <input type="hidden" name="Localizador" value={reserva != null ? reserva.localizador : -1} />
                                    <input type="hidden" name="Id_Reserva" value={reserva != null ? reserva.id_Instalacion : -1} />
                                    <input type="hidden" name="id_Tramo" value={reserva != null ? reserva.id_Tramo : -1} />
                                    <input type="hidden" name="Fecha" value={reserva != null ? reserva.fecha : ""} />
                                    <input type="hidden" name="Cantidad" value={Totales.totalplazas} />
                                    <input type="hidden" name="Precio" value={Totales.totalprecio} />                                    
                                    <input type="hidden" name="DataExtras" value={extraselected != null && extraselected.length > 0 ? JSON.stringify(extraselected) : ""} /> 
                                    <input type="hidden" name="DuracionHorariaRsv" value={horas} />        
                                </form>
                            <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={1}>
                                Resumen de precio
                                </MDTypography>
                                {ResumenReservaMUI(Totales.conceptosresumen, Totales.totalprecio)}
                            <Grid container spacing={1} mt={2}>                               
                                <Grid item xs={12}>
                                        <Button fullWidth variant="contained" color="primary" size="large" onClick={grabarAmpliarReserva}>
                                        Ampliar Reservar Ahora
                                    </Button>
                                </Grid>
                                </Grid>                             
                                <MDBox mt={2}>
                                    <MDTypography variant="body2"
                                        onClick={() => setShowCodigoDescuento(!showCodigoDescuento)}
                                        sx={{
                                            color: 'black',
                                            fontWeight: 400,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            userSelect: 'none',
                                        }}
                                    >                                    
                                        {showCodigoDescuento ? <ExpandLessIcon sx={{ mr: 1 }} /> : <ExpandMoreIcon sx={{ mr: 1 }} />}
                                        Aplicar código de descuento
                                    </MDTypography>
                                    <Collapse in={showCodigoDescuento}>
                                        <MDBox mt={2} display="flex" alignItems="center" gap={2} flexWrap="wrap">
                                            <TextField
                                                label="Código de descuento"
                                                size="small"
                                                variant="outlined"
                                                value={codigoDescuento}
                                                onChange={(e) => setCodigoDescuento(e.target.value)}
                                                error={errorCodigoDescuento}
                                            />
                                            <Button
                                                variant="contained"
                                                color="dark"
                                                onClick={handleAplicarCodigoDescuento}
                                                sx={{ height: '40px' }}
                                            >
                                                Aplicar
                                            </Button>
                                        </MDBox>
                                        {errorCodigoDescuento && (
                                            <MDTypography color="error" variant="body2" mt={1}>
                                                El código ingresado no es válido.
                                            </MDTypography>
                                        )}
                                    </Collapse>
                                </MDBox>
                        </CardContent>
                    </Card>
                </Grid>                
            </Grid>                                   
               {getNavegacionPaso(pasoAtras)}
            </MDBox>
        </Grid>
    }

    function renderPagarReserva(user, pago) {
        let formulariopago = "";

        
        let pagocontado = "";

        if (pago != null) {
            if (user != null && (user.id_Rol == Roles.SuperUsuario || user.id_Rol == Roles.Administrador))
            {
                pagocontado =
                    <Grid item xs={6} sm={6} pr={1}>
                    <Button fullWidth color="twitter" href={pago.urlokcontado }>Pago Contado</Button>
                    </Grid>
            } 

            //Si estamos con Paygold
            if (pago.driver == "RedSys") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver} method="post">
                    <input runat="server" type="hidden" id="Ds_SignatureVersion" name="Ds_SignatureVersion" value={pago.ds_SignatureVersionGold} /> 
                    <input runat="server" size="100" type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" value={pago.ds_MerchantParametersGold} />
                    <input runat="server" type="hidden" size="50" id="Ds_Signature" name="Ds_Signature" value={pago.ds_SignatureGold} />               
                        <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>                    
                </form></Grid>)
            }
            else if (pago.driver == "PayComet") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosComet} method="post">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid>)
            }
            else if (pago.driver == "AddOnPayments") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosAddOn} method="post">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid >);
            }
            else if (pago.driver == "CecaBank") {
                formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosCecabank} method="post" encType="application/x-www-form-urlencoded">
                    <Button fullWidth color="primary" type="submit" onClick={realizarPago}>Realizar Pago</Button>
                </form></Grid>)
            }
        }
        
        return <Grid container xs={12} mt={1}>{formulariopago} {pagocontado}</Grid>;
    }
   
    function renderPasosReserva()
    { 
        let paso1 = "";
        let paso2 = "";
        let paso3 = "";
        let paso4 = "";        
      
        if (paso >= 1) {
            paso1 = <Grid container>
                {getTituloPaso(1, paso)}
                {paso == 1 ? renderSelecionTramos() : ""}               
            </Grid>
        }
        
        if (paso >= 2) {
            paso2 = <Grid container>
                {getTituloPaso(2, paso)}
                {paso == 2 ? renderExtrasReserva() : ""}
                {paso === 2 ? getNavegacionPaso(pasoAtras) : ""}
            </Grid>
        }

        if (paso >= 3) {
            paso3 = <Grid container>
                {getTituloPaso(3, paso)}
                {paso == 3 ? renderDatosReserva( props.user) : ""}
            </Grid>
        }

        if (paso >= 4) {
            paso4 = <Grid container>
                {getTituloPaso(4, paso)}
                <Grid item xs={12} mx={1}>
                    {TratarTexto("Pulse el botón de <strong> Realizar el pago</strong> para completar la ampliacion de la reserva")}
                    {TratarTexto("<strong>ATENCIÓN:</strong> Las ampliaciones sin pagar serán canceladas automáticamente si no se realiza el pago.")}
                </Grid>
                {paso == 4 ? <Grid item xs={12} >{renderPagarReserva(props.user, infopago)}</Grid> : ""}
            </Grid>
        }

        return (
            <Grid item xs={12}>
                {Boolean(reserva?.imagebannerreservas) && (
                    <Grid container>
                        <Grid item xs={12}>
                            <MDBox
                                component="img"
                                src={reserva.imagebannerreservas}
                                alt="Banner Reservas"
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: 150,
                                        sm: 180,
                                        md: 250,
                                        lg: 300,
                                        xl: 350
                                    },
                                    objectFit: 'cover',
                                    border: '0.5px solid #eeeeee',
                                    borderRadius: 1,
                                    mb: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                )}               
                {/*totalreserva*/}
                <MDBox px={1}>
                    {paso1}
                    {paso2}
                    {paso3}
                    {paso4}                   
                </MDBox>              
                <br />
            </Grid>
        );
    }

    function renderCargando()
    {
         return <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
                minHeight: 140,
                backgroundColor: "rgba(0, 0, 0, 0.6)",  // Fondo oscuro semi-transparente
                borderRadius: 2,
                padding: {
                    xs: "20px",  // Para dispositivos pequeños (móviles)
                    sm: "20px 40px",  // Para pantallas más grandes
                },
                boxShadow: 2,
                width: "100%", // Asegura que ocupe todo el ancho disponible
                position: "absolute", // Lo coloca sobre la imagen de fondo
                top: "50%", // Centrado verticalmente
                left: "50%",
                transform: "translate(-50%, -50%)", // Ajusta el centro
            }}
        >
            <CircularProgress color="secondary" size={50} sx={{ marginRight: 2 }} />
            <MDTypography variant="body1" color="white" fontWeight="400">
                Cargando...
            </MDTypography>
        </MDBox>
    }  

    function renderError(error) {

        return <MDBox mt={2}>
            <Alert
                severity="error"
                variant="outlined"
                sx={{
                    fontSize: "0.9rem",
                    color: "error.main",
                    borderColor: "error.light",
                    backgroundColor: "#fff8e1",
                    paddingY: 1,
                    paddingX: 2,
                    alignItems: "center"
                }}
            >
                {error}
            </Alert>
        </MDBox>

    }

    let formulario = loading ? renderCargando() : renderPasosReserva()

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";
   
    return <>               
        <Grid container>
        <Grid item xs={12} sm={12} md={12}>
            {alerta}
            </Grid>            
            {formulario}        
            <Grid item xs={12}>
                {infoextraerror != null && infoextraerror != "" ? renderError(infoextraerror) : ""}
            </Grid>
            <Grid item xs={12}>
                {erroralert != null && erroralert != "" ? renderError(erroralert) : ""}  
            </Grid>
            <Grid item xs={12} sm={12} md={12} mt={3}>
                <OthelloFooter />
            </Grid>            
        </Grid>         
    </>
}

//propTypes = {
//    user: PropTypes.object,    
//    onResultReserva: PropTypes.object
//};